import { createStore } from 'vuex'
const USER_STORAGE_KEY = 'usuario_cliente'
const MODULES_STORAGE_KEY = 'modulos_cliente'
const SUBSCRIPTION_STORAGE_KEY = 'suscripcion_cliente'
const USER_STORAGE_KEY_LEGADO = 'client_user'
const MODULES_STORAGE_KEY_LEGADO = 'client_modules'
const SUBSCRIPTION_STORAGE_KEY_LEGADO = 'client_subscription'

const MODULE_CODE_MAP = Object.freeze({
  dashboard: '1',
  personas: '2',
  ventas: '3',
  compras: '4',
  inventario: '5',
  finanzas: '6',
  contabilidad: '7',
  reportes: '8',
  configuracion: '9'
})

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

const loadFromStorage = (key, fallback) => {
  if (!isBrowser()) return fallback
  const raw = window.localStorage.getItem(key)
  if (!raw) return fallback
  try {
    return JSON.parse(raw)
  } catch (error) {
    console.warn(`[store] No se pudo parsear ${key} desde localStorage`, error)
    return fallback
  }
}

const loadFromStorageMulti = (keys, fallback) => {
  for (const key of keys) {
    const value = loadFromStorage(key, null)
    if (value !== null) return value
  }
  return fallback
}

const persist = (key, value) => {
  if (!isBrowser()) return
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.warn(`[store] No se pudo persistir ${key} en localStorage`, error)
  }
}

const remove = (key) => {
  if (!isBrowser()) return
  window.localStorage.removeItem(key)
}

export default createStore({
  state: {
    user: loadFromStorageMulti([USER_STORAGE_KEY, USER_STORAGE_KEY_LEGADO], null),
    modules: loadFromStorageMulti([MODULES_STORAGE_KEY, MODULES_STORAGE_KEY_LEGADO], []),
    subscription: loadFromStorageMulti([SUBSCRIPTION_STORAGE_KEY, SUBSCRIPTION_STORAGE_KEY_LEGADO], null)
  },
  getters: {
    estaAutenticado: state => Boolean(state.user),
    isSuperAdmin: state => Boolean(state.user?.is_super_admin),
    currentUser: state => state.user,
    activeModules: state => (Array.isArray(state.modules) ? state.modules : []),
    hasModule: (state, getters) => (code) => {
      if (!code) return true
      if (getters.isSuperAdmin) return true
      const moduleCodes = getters.activeModules.map(item => String(item))
      if (moduleCodes.includes(String(code))) return true
      const mainCode = MODULE_CODE_MAP[code]
      if (mainCode && moduleCodes.includes(String(mainCode))) return true
      return false
    },
    subscription: state => state.subscription,
    hasActiveSubscription: state => state.subscription?.estado === 'activa'
  },
  mutations: {
    setUser(state, user) {
      state.user = user || null
      if (user) {
        persist(USER_STORAGE_KEY, state.user)
      } else {
        remove(USER_STORAGE_KEY)
      }
    },
    setModules(state, modules) {
      state.modules = Array.isArray(modules) ? modules : []
      persist(MODULES_STORAGE_KEY, state.modules)
    },
    setSubscription(state, subscription) {
      state.subscription = subscription || null
      if (subscription) {
        persist(SUBSCRIPTION_STORAGE_KEY, state.subscription)
      } else {
        remove(SUBSCRIPTION_STORAGE_KEY)
      }
    },
    clearAuth(state) {
      state.user = null
      state.modules = []
      state.subscription = null
      remove(USER_STORAGE_KEY)
      remove(MODULES_STORAGE_KEY)
      remove(SUBSCRIPTION_STORAGE_KEY)
      remove(USER_STORAGE_KEY_LEGADO)
      remove(MODULES_STORAGE_KEY_LEGADO)
      remove(SUBSCRIPTION_STORAGE_KEY_LEGADO)
    }
  },
  actions: {
    hydrateFromStorage({ commit }) {
      commit('setUser', loadFromStorageMulti([USER_STORAGE_KEY, USER_STORAGE_KEY_LEGADO], null))
      commit('setModules', loadFromStorageMulti([MODULES_STORAGE_KEY, MODULES_STORAGE_KEY_LEGADO], []))
      commit('setSubscription', loadFromStorageMulti([SUBSCRIPTION_STORAGE_KEY, SUBSCRIPTION_STORAGE_KEY_LEGADO], null))
    }
  }
})

